import React from "react";
import { NavLink } from "react-router-dom";
import { hasMenuAccess } from "../lib/utils";

const UpgradeStamp = ({ onUpgradeClick }) => (
  <div
    onClick={onUpgradeClick}
    className="absolute cursor-pointer top-1/2 right-2 transform -translate-y-1/2 shrink-menu-stamp z-10 group-hover:block hidden"
  >
    {/* For expanded menu */}
    <span className="shrink-menu-hide bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-white font-bold px-2 py-1 rounded-full shadow-lg cursor-pointer hover:scale-105 transition-transform text-xs pointer-events-none">
      UPGRADE TO PRO
    </span>
    {/* For shrunk menu - just a small dot */}
    <span className="shrink-menu-show w-3 h-3 rounded-full bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] shadow-lg"></span>
  </div>
);

const MenuWithUpgradeStamp = ({
  menuKey,
  to,
  extraTo,
  pathname,
  icon,
  label,
  onUpgradeClick,
  isActive,
  searchParams,
  className = "",
  children,
  ...props
}) => {
  // Determine if this is a NavLink with search params or regular NavLink
  const linkProps = searchParams
    ? {
        to: {
          pathname: to,
          search: searchParams,
        },
      }
    : { to };

  // Determine active state
  const activeClass =
    isActive || pathname === to || pathname?.includes(extraTo) ? "active" : "";

  return (
    <li className={`relative ${className}`} {...props}>
      {hasMenuAccess(menuKey) ? (
        <NavLink className={`nav-link ${activeClass}`} {...linkProps}>
          <span>
            <svg className="icon">
              <use href={icon}></use>
            </svg>
          </span>
          <strong>{label}</strong>
          {children}
        </NavLink>
      ) : (
        <div className="relative group">
          {/* Background menu (disabled state) */}
          <div
            className={`nav-link opacity-50 cursor-pointer ${activeClass}`}
            onClick={onUpgradeClick}
          >
            <span>
              <svg className="icon">
                <use href={icon}></use>
              </svg>
            </span>
            <strong>{label}</strong>
            {children}
          </div>
          {/* Upgrade stamp - only visible on hover */}
          <UpgradeStamp onUpgradeClick={onUpgradeClick} />
        </div>
      )}
    </li>
  );
};

export default MenuWithUpgradeStamp;
